export const PAGE_KINDS = {
  cart: 'shopping cart',
  category: 'category',
  checkout: 'checkout',
  homepage: 'homepage',
  myList: 'my saves',
  pickedForYou: 'pickedForYou',
  product: 'product',
};

export const MOBILE_SIGN_IN_MENU_FRONTEND = 'MobileSignInMenuFrontend';

/**
 * Path used for analytics account tracking
 * Used in analytics data collection and reporting
 */
export const ANALYTICS_ACCOUNT_PATH = 'analytics.global.account';

/**
 * Defines the possible authentication states of a user
 * GUEST: User is not logged in
 * AUTHENTICATED: User is actively logged in
 * REMEMBERED: User's session is persisted (remember me functionality)
 */
export const USER_STATES = {
  GUEST: 'guest',
  AUTHENTICATED: 'authenticated',
  REMEMBERED: 'remembered',
};
